module.exports = __webpack_public_path__ + "static/media/LV.b0c9356c.png";